// @flow

import React from "react";
import RadioGroup from "../RadioGroup";

import type { InputType } from "../Input/TextInput";

import styles from "./YesNoRadioGroup.scss";

export const options = [
  {
    label: "Ja",
    value: true
  },
  {
    label: "Nein",
    value: false
  }
];

type YesNoRadioGroupProps = {
  input: InputType,
  isDisabled: boolean
};

const YesNoRadioGroup = ({ input, isDisabled }: YesNoRadioGroupProps) => (
  <div className={styles.container}>
    <RadioGroup input={input} options={options} isDisabled={isDisabled} />
  </div>
);

export default YesNoRadioGroup;
